module.exports = __webpack_public_path__ + "static/img/Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.fc027be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.jpg
// module id = 85
// module chunks = 1